


























































































































/**
 * https://www.digitalocean.com/community/tutorials/vuejs-vue-modal-component
 */
import { Mixins, Component, Prop, Watch } from "vue-property-decorator";
import { FreightRequest } from "@/models/order/order";
import { DeliveryServices, ShippingAddressType } from "@/models/order/helpers";
import { Mobile } from "@/mixins/mobile";

@Component
export default class SaveQuoteModal extends Mixins(Mobile) {
  @Prop() newFreight!: FreightRequest;
  @Prop({default: false}) showFreightOptions!: boolean;
  @Prop({default: true}) requestReady!: boolean;

  protected updatedFreight = {} as FreightRequest;
  protected shippingAddressTypeOptions: string[] = Object.values(ShippingAddressType);
  protected deliveryServiceOptions: string[] = Object.values(DeliveryServices);
  protected selectAddressType: ShippingAddressType | "" = "";
  protected selectDeliveryService: DeliveryServices | "" = "";

  created(): void {
    this.updatedFreight = Object.assign({}, { ...this.newFreight });
  }

  @Watch("freight")
  protected watchFreight(): void {
    this.updatedFreight = this.newFreight;
  }

  protected handleAddressTypeOption(): void {
    if (this.updatedFreight.addressType === ShippingAddressType.Residential && this.selectAddressType !== ShippingAddressType.Residential) {
      this.selectDeliveryService = "";
      this.updatedFreight.services = "";
    } else {
      this.updatedFreight.addressType = this.selectAddressType as ShippingAddressType;
      if (this.isResidential) {
        this.selectDeliveryService = DeliveryServices.Both;
        this.updatedFreight.services = DeliveryServices.Both;
      }
    }
    this.updateFreight();
  }

  get isResidential(): boolean {
    return this.selectAddressType === ShippingAddressType.Residential;
  }

  protected handleDeliveryServiceOption(): void {
    this.updatedFreight.services = this.selectDeliveryService as DeliveryServices;
    this.updateFreight();
  }

  protected handleZipInput(zip: string): void {
    this.updatedFreight.shippingZip = zip;
    this.updateFreight();
  }

  protected handleFreightOptions(event: Event, isAddressType: boolean): void {
    if (isAddressType) {
      this.updatedFreight.addressType = this.handleSelectorValue((event.target as HTMLSelectElement).value) as ShippingAddressType;
    } else {
      this.updatedFreight.services = this.handleSelectorValue((event.target as HTMLSelectElement).value) as DeliveryServices;
    }
    this.updateFreight();
  }

  protected handleSelectorValue(selectorValue: any): string {
    return selectorValue === "" ? null : selectorValue;
  }

  protected toggleFreightOptions(): void {
    this.$emit("toggleFreightOptions");
  }

  protected updateFreight(): void {
    this.$emit("update:newFreight",this.updatedFreight)
  }

  protected submitFreight(): void {
    this.$emit('submitFreight');
  }

  protected close(): void {
    this.resetModal();
    this.$emit('close');
  }

  protected resetModal(): void {
    const selects = document.querySelectorAll('select');
    selects.forEach(select => {
      select.value = select.options[0].value;
    });
    this.selectAddressType = "";
    this.selectDeliveryService = "";
    this.updatedFreight = {
      addressType: null,
      requestDate: null,
      shippingZip: null,
      services: null,
      updatedDate: null
    };
    this.updateFreight();
  }

}
